import * as React from 'react';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet';

interface Props {
  title?: string;
  description?: string;
  lang?: string;
  url?: string;
  ogImageUrl?: string;
  meta?: [];
  children?: React.ReactNode;
  closeFromIndexing?: boolean;
}

const Seo = ({ description, lang, meta, title, url, children, ogImageUrl, closeFromIndexing }: Props) => {
  return (
    <Helmet
      htmlAttributes={{
        lang,
      }}
      title={title}
      meta={[
        {
          name: `description`,
          content: description,
        },
        {
          property: `og:title`,
          content: title,
        },
        {
          property: `og:description`,
          content: description,
        },
        {
          property: 'og:url',
          content: url,
        },
        {
          property: 'og:image',
          content: ogImageUrl,
        },
        {
          property: `og:type`,
          content: `website`,
        },
        {
          name: `twitter:card`,
          content: `summary`,
        },
        {
          name: `twitter:title`,
          content: title,
        },
        {
          name: `twitter:description`,
          content: description,
        },
        closeFromIndexing ? { name: `robots`, content: `noindex` } : undefined,
      ]
        .filter(Boolean)
        .concat(meta)}
    >
      {children}
    </Helmet>
  );
};

Seo.defaultProps = {
  lang: `en`,
  meta: [],
  description: ``,
};

Seo.propTypes = {
  description: PropTypes.string,
  lang: PropTypes.string,
  meta: PropTypes.arrayOf(PropTypes.object),
  title: PropTypes.string.isRequired,
};

export default Seo;
